<template>
  <div class="saved-alert">
    <div v-if="saved" class="d-contents">
      <CheckIcon class="icon-12px mr-8" />
      <span class="text-ss success-700">{{ $t('Saved') }}</span>
    </div>
    <DotsHorizontal v-else class="dots" />
  </div>
</template>

<script>
  import CheckIcon from '@/assets/icons/success.svg';
  import DotsHorizontal from '@/assets/icons/dots-horizontal.svg';

  export default {
    name: 'SavedAlert',
    components: { CheckIcon, DotsHorizontal },
    props: {
      saved: Boolean,
    },
  };
</script>

<style scoped>
  .dots {
    margin-left: auto;
  }
  .saved-alert {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: 4px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 4px;
    color: #00ca7d;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    min-width: 65px;
    height: 20px;
  }
</style>
